<template>
	<el-dialog
		:visible.sync="show"
		width="45%"
		:close-on-click-modal="!leaving"
		:show-close="!leaving"
		:close-on-press-escape="!leaving"
	>
		<div v-if="!leaving">
			<h2>{{ $t("groups.leave-group.title", { name: name}) }}</h2>
			<p v-if="!owner">{{ $t("groups.leave-group.user-message") }}</p>
			<p v-if="owner">{{ $t("groups.leave-group.owner-message") }}</p>
			<el-button size="mini" @click="toggleGroupLeaveModal">{{ $t("common.cancel") }}</el-button>
			<el-button size="mini" @click="leaveGroup" type="danger">{{ $t("common.leave") }}</el-button>
		</div>
		<div v-if="leaving" class="leaving">
			<p>{{ $t("groups.leave-group.leaving-group") }}</p>
			<i class="fas fa-circle-notch fa-spin"></i>
		</div>
	</el-dialog>
</template>

<script>
import { mapActions } from "vuex";

export default {
	name: "TheGroupModalLeave",
	computed: {
		show: {
			get() {
				return this.$store.getters.groupLeaveIsInvisible;
			},
			set() {
				return this.$store.commit("toggleGroupLeave");
			},
		},
		name: {
			get() {
				return this.$store.getters.getGroupName;
			},
		},
		roomId: {
			get() {
				return this.$store.getters.getRoomId;
			},
		},
		gid: {
			get() {
				return this.$store.getters.getGid;
			},
		},
		owner: {
			get() {
				return this.$store.getters.getOwner;
			},
		},
	},
	data() {
		return {
			leaving: false,
		};
	},
	methods: {
		...mapActions(["deleteMemberOfGroup","toggleGroupLeaveModal"]),
		leaveGroup() {
			const user = this.$store.state.user.user;
			this.leaving = true;
			this.deleteMemberOfGroup({
				roomId: this.roomId,
				gid: this.gid,
				uid: user.uid,
				action : 'leave'
			}).then(() => {
				if (window.location.pathname === `/messages/${this.gid}`) {
					this.$router.push({ name : "Messages"});
				}
				this.leaving = false;
				this.show = false;
			});
		},
	},
};
</script>

<style scoped>
	div {
		text-align: center;
	}
	h2, p, button {
		margin-bottom: var(--column);
	}
	.fa-circle-notch {
		color: var(--blue);
		font-size: 24px;
	}
</style>
